module.exports = {
  STRAPI_URL: 'https://strapi.decadeoftrax.com',
  OKTA_ISSUER: 'https://traxretail.okta.com',
  OKTA_CLIENT_ID: '0oa8s34zlba9OdlZu2p7', // trax
  // OKTA_ISSUER: 'https://dev-8591331.okta.com', // sandbox
  // OKTA_CLIENT_ID: '0oaatrcxv6ft5rz8Q5d5', // sandbox
};
